import * as React from 'react';
import { useState } from 'react';
import classNames from 'classnames';
import styles from './checkbox.module.scss';

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
    label?: string;
    labelElement?: React.ReactNode;
    labelAttributes?: React.HTMLAttributes<HTMLLabelElement> & { 'data-testid'?: string };
    wrapperAttributes?: React.HTMLAttributes<HTMLDivElement>;
    name: string;
    id: string;
    renderChecked?: boolean;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox = ({
    name,
    renderChecked,
    id,
    handleChange,
    label,
    labelElement,
    labelAttributes,
    wrapperAttributes,
    ...props
}: CheckboxProps) => {
    const [isChecked, setIsChecked] = useState(renderChecked ?? false);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(e.target.checked);
        handleChange && handleChange(e);
    };

    return (
        <div className={classNames(styles.checkbox, wrapperAttributes?.className ?? '')}>
            <input type="checkbox" id={id} name={name} checked={isChecked} onChange={onChange} {...props} />
            <label htmlFor={id} {...labelAttributes}>
                {label ?? labelElement}
            </label>
        </div>
    );
};

export const ControlledCheckbox = ({
    name,
    id,
    handleChange,
    label,
    labelElement,
    labelAttributes,
    wrapperAttributes,
    ...props
}: Omit<CheckboxProps, 'renderChecked'>) => (
    <div className={classNames(styles.checkbox, wrapperAttributes?.className ?? '')}>
        <input type="checkbox" id={id} name={name} onChange={handleChange} {...props} />
        <label htmlFor={id} {...labelAttributes}>
            {label ?? labelElement}
        </label>
    </div>
);
